interface ClickOutsideElement extends HTMLElement {
  _clickOutside: {
    callback: (e: MouseEvent) => void;
    handler: (e: MouseEvent) => void;
  };
}

/**
 * Click outside directive with debug
 */
export default {
  bind(el, binding) {
    el.__clickOutsideHandler__ = function(event) {
      
      // Check if click was outside the el and its children
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      } else {
        console.log('v-click-outside: Click was inside element - ignoring');
      }
    };
    
    // Add event listener for mousedown
    document.addEventListener('mousedown', el.__clickOutsideHandler__);
  },
  
  unbind(el) {
    document.removeEventListener('mousedown', el.__clickOutsideHandler__);
    delete el.__clickOutsideHandler__;
  }
};
